export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-10">
          关于我们
        </h2>
        <div className="max-w-4xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/70">
            <div className="flex flex-col md:flex-row items-center gap-8 mb-8">
              <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-primary-400 to-primary-600 flex items-center justify-center flex-shrink-0">
                <span className="text-3xl font-heading text-background-50">羞</span>
              </div>
              <div>
                <h3 className="text-xl font-heading text-foreground-900 mb-3">羞羞歪歪漫画</h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  羞羞歪歪漫画是一个专注于提供高质量漫画阅读体验的在线平台。我们致力于收集和呈现最优质的漫画作品，以全部章节无删减、下拉式竖屏阅读为核心特色，为漫画爱好者打造最舒适的在线看入口。
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 text-center">
              <div className="p-4">
                <div className="text-3xl font-heading text-primary-500 mb-1">2000+</div>
                <p className="text-xs text-foreground-500">漫画资源</p>
              </div>
              <div className="p-4">
                <div className="text-3xl font-heading text-accent-500 mb-1">100万+</div>
                <p className="text-xs text-foreground-500">月活读者</p>
              </div>
              <div className="p-4">
                <div className="text-3xl font-heading text-secondary-500 mb-1">5年</div>
                <p className="text-xs text-foreground-500">持续运营</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}